import { Box } from "@mui/material";
import React from "react";
import { memo } from "react";
import Checkbox from "../../../../../../../Components/CheckBox/Checkbox";
import { nodeInputStyles } from "../../GeneralNodeStyles";

const MetricType = memo(({ data, metricType, setMetricType, organization }) => {
  const { setBotData, nodeId } = data;

  const handleMetricChange = (event, type) => {
    const metric_type = { ...metricType };
    metric_type[type] = event.target.checked;

    // Check if at least one checkbox is selected in the metric category
    const isSelected = Object.values(metric_type).some((value) => value);
    if (!isSelected) {
      // If no checkbox is selected, default to the first checkbox (e.g., 'cosine')
      metric_type["cosine"] = true;
    }
    setMetricType({ ...metric_type });
    localStorage.setItem(`metricType_${nodeId}`, JSON.stringify(metric_type));

    setBotData((prevData) => ({
      ...prevData,
      workflow: {
        ...prevData.workflow,
        [`${nodeId}`]: {
          ...prevData.workflow[`${nodeId}`],
          metric: { ...metric_type },
        },
      },
    }));
  };

  return (
    <Box
      sx={{
        ...nodeInputStyles,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Checkbox
        label="Cosine"
        onChange={(event) => handleMetricChange(event, "cosine")}
        checked={metricType.cosine}
      />
      <Checkbox
        label="Dot Product"
        onChange={(event) => handleMetricChange(event, "dotproduct")}
        checked={metricType.dotproduct}
      />
      <Checkbox
        disabled={organization?.organization?.subscription === "starter"}
        label="Euclidean"
        onChange={(event) => handleMetricChange(event, "euclidean")}
        checked={metricType.euclidean}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />
      <Checkbox
        disabled={organization?.organization?.subscription === "starter"}
        label="Hybrid"
        onChange={(event) => handleMetricChange(event, "hybrid")}
        checked={metricType.hybrid}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />
      <Checkbox
        disabled={organization?.organization?.subscription === "starter"}
        label="Cosine + Sparse"
        onChange={(event) => handleMetricChange(event, "cosine+sparse")}
        checked={metricType["cosine+sparse"]}
        tooltipText={
          organization?.organization?.subscription === "starter"
            ? "You need Pro subscription to access this feature."
            : "Half of the chunks will be retrieved using sparse encoding, while the other half will be fetched using cosine similarity."
        }
        tooltipPlacement="left"
      />
    </Box>
  );
});
export default MetricType;
